export const PREVIEW_MAX_BYTES = 200 * 1024 * 1024;
export const PREVIEW_LIMIT_MESSAGE = '文件超过200MB，建议下载原文件后打开';

export function checkPreviewSize(bytes, max = PREVIEW_MAX_BYTES) {
  if (max && Number(bytes) > max) throw new Error(PREVIEW_LIMIT_MESSAGE);
}

export async function previewBlob(response, max = PREVIEW_MAX_BYTES) {
  checkPreviewSize(response.headers.get('Content-Length'), max);
  // Stop oversized responses even when the server omits Content-Length.
  if (max && response.body?.getReader) {
    const reader = response.body.getReader(), chunks = [];
    let bytes = 0;
    try {
      while (true) {
        const item = await reader.read();
        if (item.done) break;
        bytes += item.value.byteLength;
        checkPreviewSize(bytes, max);
        chunks.push(item.value);
      }
    } catch (error) { await reader.cancel().catch(() => {}); throw error; }
    finally { reader.releaseLock(); }
    return new Blob(chunks, {type:response.headers.get('Content-Type') || 'application/octet-stream'});
  }
  const blob = await response.blob();
  checkPreviewSize(blob.size, max);
  return blob;
}
